import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";
import {TicketsService} from "@app/services/tickets/tickets.service";
import {PortalUser} from "@app/model/portal-user.model";
import {LoginService} from "@app/login/login.service";
import {AlertsService} from "@app/services/misc-services/alerts.service";
import {GlobalSpinnerService} from "@app/services/misc-services/global-spinner.service";
import {MatDialog} from "@angular/material/dialog";
import {SecurityImagesComponent} from "@app/pages/tickets/hra/security-images/security-images.component";
import {MatSelectionListChange} from "@angular/material/list";

@Component({
  selector: 'flex-hra',
  templateUrl: './hra.component.html',
  styleUrls: ['./hra.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HraComponent implements OnInit {
  activeUser: PortalUser;
  methods: MethodModel[] = [
      {displayImage: false, selectImage: false, captcha: false, securityWord: false, challengeQuestion: false, emailAuth: false, displayImageList: [] = [], selectImageList: [] = []},
      {displayImage: false, selectImage: false, captcha: false, securityWord: false, challengeQuestion: false, emailAuth: false, displayImageList: [] = [], selectImageList: [] = []}
  ];
  typeList: string[] = ['Display Image', 'Select Image', 'Captcha',
    'Security Word','Challenge Question', 'Email Authentication']
  actionList: HighRiskActionModel[] = [
    {action: 'Login', method: null, perMonth: null},
    {action: 'Transfers', method: null, perMonth: null, amounts: null},
    {action: 'Withdrawals', method: null, perMonth: null, amounts: null},
    {action: 'YTD Summary', method: null, perMonth: null},
    {action: 'Outstanding NSF', method: null, perMonth: null},
    {action: 'Pending ACH', method: null, perMonth: null},
    {action: 'Holds and Pledges', method: null, perMonth: null},
    {action: 'Money Desktop', method: null, perMonth: null},
    {action: 'Loan App', method: null, perMonth: null},
    {action: 'Statements', method: null, perMonth: null},
    {action: 'Secure Messaging', method: null, perMonth: null},
    {action: 'Deposit', method: null, perMonth: null},
    {action: 'E-Alerts', method: null, perMonth: null},
    {action: 'Change Password', method: null, perMonth: null},
    {action: 'Change Suffix Description', method: null, perMonth: null},
    {action: 'Change Username', method: null, perMonth: null},
    {action: 'Change Address', method: null, perMonth: null},
    {action: 'Manage Emails', method: null, perMonth: null},
    {action: 'Bill Pay', method: null, perMonth: null},
    {action: 'Check Order', method: null, perMonth: null},
    {action: 'View Documents', method: null, perMonth: null},
    {action: 'Credit Card Statements', method: null, perMonth: null},
    {action: 'Update Security', method: null, perMonth: null},
    {action: 'Loan App Classic', method: null, perMonth: null},
  ]
  hasChanged: boolean = false;
  constructor(private http: HttpClient, private router: Router, public ticketsService: TicketsService,
              private currentUser: LoginService, public alert: AlertsService,
              private globalSpinner: GlobalSpinnerService, public imageDialog: MatDialog) { }
  ngOnInit(): void {
    this.activeUser = this.currentUser.activeUser;
  }
  fieldChanged() {
    this.hasChanged = true;
  }
  selectImages(methodNum: number, selectedList: number) {
      const dialogRef = this.imageDialog.open(SecurityImagesComponent, {
        data: {method: this.methods[methodNum], listOption: selectedList}
      });
      dialogRef.afterClosed().subscribe((response: MethodModel) => {
        if (response != null){
          this.methods[methodNum] = response
        }
      })
  }
  openImageSelection(methodNumber: number, change: MatSelectionListChange) {
    this.fieldChanged()
    let lastSelected = change.options[0].value
    let listOption: number;
    if (lastSelected === this.typeList[0] && change.options[0].selected === true ||
        lastSelected === this.typeList[1] && change.options[0].selected === true) {
      if (lastSelected === this.typeList[0]) {
        listOption = 0;
      } else {
        listOption = 1;
      }
      this.selectImages(methodNumber, listOption)
    } else {
      return;
    }
  }
  changeMethod(method: number, id: number) {
    switch (id) {
      case 0:
        this.methods[method].displayImage = !this.methods[method].displayImage;
        break;
      case 1:
        this.methods[method].selectImage = !this.methods[method].selectImage;
        break;
      case 2:
        this.methods[method].captcha = !this.methods[method].captcha;
        break;
      case 3:
        this.methods[method].securityWord = !this.methods[method].securityWord;
        break;
      case 4:
        this.methods[method].challengeQuestion = !this.methods[method].challengeQuestion;
        break;
      case 5:
        this.methods[method].emailAuth = !this.methods[method].emailAuth;
        break;
    }
  }
  createHraRequest(): string {
    let returnString: string = '';
    for(let i = 0; i < this.actionList.length; i++) {
      let action = this.actionList[i];
      if(action.method != null || action.perMonth != null || action.amounts != null) {
        returnString = `${returnString} + ${action.action}: Method ${action.method}\nActions/30:${action.perMonth}\n`;
        if (action.amounts) {
          returnString = `${returnString}Amount/30:${action.amounts}\n\n`;
        } else {
          returnString = `${returnString}\n`;
        }
      }
    }
    if (returnString === '') {
      returnString = `No action changes, only changes to methods.\n\n`
    }
    for(let i = 0; i < 2; i++) {
      returnString = returnString + `Method: ' + ${(i +1)}\n
          Display Image:${this.methods[i].displayImage}\n'
          Select Image:${this.methods[i].selectImage}\n'
          Captcha:${this.methods[i].captcha}'\n
          Security Word:${this.methods[i].securityWord}\n
          Challenge Question:${this.methods[i].challengeQuestion}\n
          Email Authentication:${this.methods[i].emailAuth}\n`
      if (this.methods[i].displayImageList != null) {
        returnString = returnString + `Display Images:${this.methods[i].displayImageList}\n`;
      }
      if (this.methods[i].selectImageList != null) {
        returnString = `${returnString}Select Images:${this.methods[i].selectImageList}\n`;
      }
      returnString = `${returnString}\n`
    }
    return `${returnString}\n`;
  }
  saveHRA() {
    this.globalSpinner.addEvent('hraStart')

    this.ticketsService.createHraTicket(
        this.ticketsService.createNoteDTO(this.createHraRequest(), this.activeUser, 0),
        this.activeUser).subscribe(() => {
      this.globalSpinner.removeEvent('hraStart')
      this.alert.getAlert('HRA ticket created', 'X');
    },
        () => {
          this.globalSpinner.removeEvent('hraStart')
          this.alert.getError('Error sending request, try again', 'X')
        })
  }
  toTickets(){
    this.router.navigate(['/tickets']).then()
  }
}

export class HighRiskActionModel {
  action: string;
  method: number = null;
  perMonth: boolean = null;
  amounts?: number = null;
}
export class MethodModel {
  displayImage: boolean;
  selectImage: boolean;
  captcha: boolean;
  securityWord: boolean;
  challengeQuestion: boolean;
  emailAuth: boolean;
  displayImageList: string[];
  selectImageList: string[];
}
